import {JoinRegisteredRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/JoinRegisteredRequest';
import {JoinRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/JoinRequest';
import {CheckInviteCodeResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/CheckInviteCodeResponse';
import {ProfileResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/ProfileResponse';
import {Response} from '@mintdata-wsp/common/controllers/network/generated/responses/Response';
import {API} from '@mintdata-wsp/common/controllers/network/WorkspaceAPI';

export class InviteController {
    public checkInviteCode(inviteCode: string): Promise<CheckInviteCodeResponse> {
        return API.invite.checkUserInvitation(inviteCode);
    }

    public requestInvitationResend(inviteCode: string): Promise<Response> {
        return API.invite.requestInvitationResend(inviteCode);
    }

    public join(request: JoinRequest): Promise<ProfileResponse> {
        return API.invite.join(request);
    }

    public joinRegistered(request: JoinRegisteredRequest): Promise<ProfileResponse> {
        return API.invite.joinRegistered(request);
    }
}
